<template>
  <span>{{ showNum }}</span>
</template>
<script>
export default {
  name: 'ScrollNumber',
  props: {
    val: {
      type: Number
    },
    preNum: {
      type: Number
    }
  },
  data () {
    return {
      showNum: this.preNum || 0,
      interval: null,
      step: this.preNum > this.val ? -1 : 1
    }
  },
  mounted () {
    if (/\d/.test(this.val)) this.animate()
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    animate () {
      this.interval = setInterval(() => {
        if (this.showNum === Number(this.val)) {
          clearInterval(this.interval)
        } else {
          this.showNum += this.step
        }
      }, 150)
    }
  }
}
</script>
<style lang="sass"></style>
